import { gql } from '@apollo/client';

import {
  SyncSessionTimestampDocument,
  type SyncSessionTimestampMutation,
  type SyncSessionTimestampMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation SyncSessionTimestamp($input: SyncSessionTimestampInput!) {
      syncSessionTimestamp(input: $input)
    }
  `;
}

export const SYNC_SESSION_TIMESTAMP = SyncSessionTimestampDocument;
export type {
  SyncSessionTimestampMutation,
  SyncSessionTimestampMutationVariables,
};
